import { Linkedin, Twitter, Facebook, Youtube, Instagram, Share2, type LucideIcon } from 'lucide-react';

export interface SocialMediaLink {
  name: string;
  url: string;
  icon: LucideIcon;
  color: string;
  isActive: boolean;
  ariaLabel: string;
}

// Centralized social media configuration
export const socialMediaLinks: SocialMediaLink[] = [
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/company/brainfyai',
    icon: Linkedin,
    color: '#0077B5',
    isActive: true,
    ariaLabel: 'Follow Brainfy AI on LinkedIn'
  },
  {
    name: 'Twitter',
    url: 'https://x.com/Brainfy_AI',
    icon: Twitter,
    color: '#1DA1F2',
    isActive: true,
    ariaLabel: 'Follow Brainfy AI on Twitter'
  },
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/share/1B9gbdnFmu/?mibextid=wwXIfr',
    icon: Facebook,
    color: '#1877F2',
    isActive: true,
    ariaLabel: 'Follow Brainfy AI on Facebook'
  },
  {
    name: 'YouTube',
    url: 'https://www.youtube.com/@BrainfyAI',
    icon: Youtube,
    color: '#FF0000',
    isActive: true,
    ariaLabel: 'Subscribe to Brainfy AI on YouTube'
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/brainfy_ai/',
    icon: Instagram,
    color: '#E4405F',
    isActive: true,
    ariaLabel: 'Follow Brainfy AI on Instagram'
  }
];

// Social sharing configuration
export const socialSharing = {
  title: 'Brainfy AI - Transform Your Business with AI',
  description: 'Canada\'s leading AI solutions provider helping businesses transform with intelligent automation.',
  url: 'https://www.brainfyai.com',
  hashtags: ['AI', 'Canada', 'BusinessTransformation', 'ArtificialIntelligence', 'BrainfyAI'],
  
  // Platform-specific sharing URLs
  twitter: (text: string, url: string) => 
    `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}&hashtags=${socialSharing.hashtags.join(',')}`,
  
  facebook: (url: string) => 
    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    
  linkedin: (url: string, title: string, summary: string) => 
    `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}&summary=${encodeURIComponent(summary)}`,
    
  email: (subject: string, body: string) => 
    `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
};

// Helper function to get active social media links
export const getActiveSocialLinks = () => socialMediaLinks.filter(link => link.isActive);

// Helper function to update social media URLs (for future use)
export const updateSocialMediaUrls = (updates: Partial<Record<string, string>>) => {
  return socialMediaLinks.map(link => ({
    ...link,
    url: updates[link.name.toLowerCase()] || link.url
  }));
};